import { render, staticRenderFns } from "./RequiredStepRegistration.vue?vue&type=template&id=260139ee&"
import script from "./RequiredStepRegistration.vue?vue&type=script&lang=js&"
export * from "./RequiredStepRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RequiredStepRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports